import { Link } from 'react-router-dom';
import Newsletter from './Newsletter';
import { CATALOG_URL, WHATSAPP_NUMBER } from '@/config/site';

type FooterLink = { label: string; path?: string; href?: string };

const colunas: { titulo: string; links: FooterLink[] }[] = [
  {
    titulo: 'Soluções',
    links: [
      { label: 'Cadeiras', path: '/cadeiras' },
      { label: 'Mesas', path: '/mesas' },
      { label: 'Móveis de aço', path: '/aco' },
      { label: 'Cabines acústicas', path: '/cabines-acusticas' },
      { label: 'Divisórias', path: '/divisorias' },
      { label: 'Marcenaria', path: '/marcenaria' },
      { label: 'Mobiliário urbano', path: '/mobiliario-urbano' },
      { label: 'Praças de alimentação', path: '/mobiliario-pracas-alimentacao' },
      { label: 'Turnkey', path: '/turnkey' },
    ],
  },
  {
    titulo: 'Segmentos',
    links: [
      { label: 'Escritórios', path: '/segmentos' },
      { label: 'Clínicas', path: '/clinicas' },
      { label: 'Escolas', path: '/escolar' },
      { label: 'Igrejas', path: '/igrejas' },
      { label: 'Advogados', path: '/advogados' },
      { label: 'Hotelaria', path: '/hotelaria' },
      { label: 'Órgãos públicos', path: '/fornecimento-orgaos-publicos' },
    ],
  },
  {
    titulo: 'Conteúdos',
    links: [
      { label: 'Projetos', path: '/cases' },
      { label: 'Blog', path: '/blog' },
      { label: 'E-books', path: '/ebooks' },
      { label: 'FAQ', path: '/faq' },
      { label: 'Glossário', path: '/glossario' },
      { label: 'Calculadora', path: '/calculadora' },
      { label: 'Consultor IA', path: '/consultoria-ia' },
    ],
  },
  {
    titulo: 'Atendimento',
    links: [
      { label: 'Solicitar orçamento', path: '/orcamento' },
      { label: 'Catálogo interativo', path: '/catalogo' },
      { label: 'Acesso do cliente', href: CATALOG_URL },
      { label: 'Rastrear pedido', path: '/rastreamento' },
      { label: 'Contato', path: '/contato' },
    ],
  },
];

const linkCls = 'text-[12px] text-[#424245] hover:text-[#1D1D1F] hover:underline underline-offset-2';

export default function Footer() {
  const tel = WHATSAPP_NUMBER.replace(/^55(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');

  return (
    <footer className="bg-[#F5F5F7] text-[#6E6E73]">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="py-12 border-b border-black/[0.08]">
          <Newsletter />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10 py-10 border-b border-black/[0.08]">
          {colunas.map((col) => (
            <div key={col.titulo}>
              <h4 className="text-[12px] font-semibold text-[#1D1D1F] mb-3 tracking-normal">{col.titulo}</h4>
              <ul className="space-y-2">
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.href ? (
                      <a href={l.href} target="_blank" rel="noopener noreferrer" className={linkCls}>
                        {l.label}
                      </a>
                    ) : (
                      <Link to={l.path!} className={linkCls}>
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[12px]">
          <div className="space-y-1">
            <p>
              HomeOffice Premium · Av. Agamenon Magalhães, 1519 — Maurício de Nassau, Caruaru — PE
            </p>
            <p>
              <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer" className="hover:text-[#1D1D1F]">
                WhatsApp {tel}
              </a>
              <span className="mx-2 text-black/20">|</span>
              <a href="mailto:ednilsonleocadio@gmail.com" className="hover:text-[#1D1D1F]">
                ednilsonleocadio@gmail.com
              </a>
            </p>
          </div>
          <div className="flex items-center gap-5">
            <a href="https://www.instagram.com/homeoffice.premium/" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-[#1D1D1F]">
              Instagram
            </a>
            <a href="https://www.youtube.com/channel/UC3BsTtRw9BYTYosHOT0E_Ew" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-[#1D1D1F]">
              YouTube
            </a>
            <Link to="/privacidade" className="hover:text-[#1D1D1F]">
              Privacidade
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
